import smb2025 from "./smb2025";
import smb2026 from "./smb2026";
import ebg2025 from "./ebg2025";
import ebg2026 from "./ebg2026";

export const constantRouterMap = [
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/404"),
    hidden: true
  },
  {
    path: "/403",
    name: "403",
    component: () => import("@/views/error403"),
    hidden: true
  },
      {
        path: "/authorize/public-data",
        name: "authorize",
        component: () => import("@/views/authorize"),
        hidden: true
      },
  {
    path: "/",
    name: "main",
    redirect: "/home",
    component: () => import("@/views/layout"),
    hidden: true,
    children: [
      {
        name: "home",
        path: "home",
        meta: {
          activename: "home"
        },
        // component: () => import("@/views/homeJudge")
        component: () => import("@/views/home")
      },
      //资讯详情页面
      {
        path: "resDetail",
        name: "resDetail",
        meta: {
          activename: "resDetail"
        },
        component: () => import("@/views/resources/resourcesDetail")
      }
    ]
  },

  { path: "*", redirect: "/404", hidden: true }
];

//menu
export const channelUserCen = [
  {
    path: "/",
    name: "home",
    redirect: "/Pending",
    component: () => import("@/views/layout/ContentMenu"),
    hidden: true,
    children: [
      {
        path: "/login",
        name: "login",
        redirect: "/"
      },
      {
        path: "Pending",
        name: "Pending",
        meta: {
          activename: "Pending"
        },
        component: () => import("@/views/channelUserCen/Pending")
      },

      {
        path: "/ContractInfolist",
        name: "ContractInfolist",
        meta: {
          activename: "ContractInfolist"
        },
        component: () => import("@/views/channelUserCen/ContractInfolist/index")
      },
      // 升级列表
      {
        path: "/UpgradeList",
        name: "UpgradeList",
        meta: {
          activename: "UpgradeList"
        },
        component: () => import("@/views/channelUserCen/UpgradeList/index")
      },
      // 渠道确认升级列表
      {
        path: "/PendingUpgrade",
        name: "PendingUpgrade",
        meta: {
          activename: "PendingUpgrade"
        },
        component: () => import("@/views/channelUserCen/UpgradeList/index")
      },
      {
        path: "ContractInformation",
        name: "ContractInformation",
        meta: {
          activename: "ContractInformation"
        },
        component: () => import("@/views/channelUserCen/ContractInformation")
      },
      {
        path: "ContractEdit",
        name: "ContractEdit",
        meta: {},
        component: () => import("@/views/channelUserCen/ContractEdiVAD")
      },
      {
        path: "channelconfirm",
        name: "channelconfirm",
        meta: {},
        component: () => import("@/views/channelUserCen/channelconfirm") //渠道确认
      },

      {
        path: "Partnerinfo",
        name: "Partnerinfo",
        meta: {},
        component: () => import("@/views/channelUserCen/Partnerinfo")
      },
      {
        path: "Franchisedinfo/:id",
        name: "Franchisedinfo",
        meta: {},
        component: () => import("@/views/channelUserCen/Franchised_Partnerinfo")
      },
      // 审批VAD 一类的
      {
        path: "ApprovalVAD",
        name: "ApprovalVAD",
        meta: {},
        component: () => import("@/views/channelUserCen/ApprovalVAD")
        // component: () => import("@/views/smbSales/approve/index")
      },
      {
        path: "VAD",
        name: "VAD",
        meta: {
          activename: "VAD"
        },
        // component: () => import("@/views/sales/VADadd") // 旧的
        // component: () => import("@/views/smbSales/apply/vad")
        // component: () => import("@/views/channelAgreement/twentyTwentyFive/SBG/apply/vad")
        component: () =>
          import("@/views/channelAgreement/twentyTwentySix/SBG/apply/vad")
      },
      {
        path: "RVAD",
        name: "RVAD",
        meta: {},
        component: () => import("@/views/sales/RVAD") // 驳回重新填写
      },
      {
        path: "ChannelResubmit",
        name: "ChannelResubmit",
        meta: {},
        component: () => import("@/views/sales/ChannelResubmit")
      },
      {
        path: "bind/success",
        name: "bindsuccess",
        meta: {},
        component: () => import("@/views/sales/Franchisedbind")
      },
      {
        path: "goldpartner",
        name: "goldpartner",
        meta: {
          activename: "goldpartner"
        },
        key: "goldpartner",
        // component: () => import("@/views/sales/GoldPartneradd") // 旧的
        // component: () => import("@/views/smbSales/apply/jp")
        // component: () => import("@/views/channelAgreement/twentyTwentyFive/SBG/apply/jp")
        component: () =>
          import("@/views/channelAgreement/twentyTwentySix/SBG/apply/jp")
      },
      {
        path: "isppartner",
        name: "isppartner",
        meta: {
          activename: "isppartner"
        },
        key: "isppartner",
        component: () =>
          import("@/views/channelAgreement/twentyTwentySix/SBG/apply/isp") // ISP Partner 2026
      },
      {
        path: "businesspartner",
        name: "businesspartner",
        meta: {
          activename: "businesspartner"
        },
        key: "businesspartner",
        component: () =>
          import("@/views/channelAgreement/twentyTwentySix/SBG/apply/business") // Business Partner 2026
      },
      {
        path: "certifiedpartner",
        name: "certifiedpartner",
        meta: {
          activename: "certifiedpartner"
        },
        component: () => import("@/views/sales/CertifiedPartnerJudge")
      },
      {
        path: "salecertified",
        name: "salecertified",
        meta: {
          activename: "salecertified"
        },
        component: () => import("@/views/sales/CertifiedPartnerad")
      },
      {
        path: "channelcertified",
        name: "channelcertified",
        meta: {
          activename: "channelcertified"
        },
        component: () => import("@/views/sales/ChannelCertified")
      },
      {
        path: "YPpartner",
        name: "YPpartner",
        meta: {
          activename: "YPpartner"
        },
        // component: () => import("@/views/sales/YPpartner") // 旧的
        // component: () => import("@/views/smbSales/apply/yp")
        // component: () => import("@/views/channelAgreement/twentyTwentyFive/SBG/apply/yp")
        component: () =>
          import("@/views/channelAgreement/twentyTwentySix/SBG/apply/yp")
      },
      {
        path: "SUBpartner",
        name: "SUBpartner",
        meta: {
          activename: "SUBpartner"
        },
        // component: () => import("@/views/sales/SUBpartner") // 旧的
        // component: () => import("@/views/smbSales/apply/sub")
        // component: () => import("@/views/channelAgreement/twentyTwentyFive/SBG/apply/sub")
        component: () =>
          import("@/views/channelAgreement/twentyTwentySix/SBG/apply/sub")
      },
      {
        path: "franchisedpartner",
        name: "franchisedpartner",
        meta: {
          activename: "franchisedpartner"
        },
        component: () => import("@/views/sales/FranchisedPartneradd")
      },
      {
        path: "globalstrategicpartner",
        name: "globalstrategicpartner",
        meta: {
          activename: "globalstrategicpartner"
        },
        component: () => import("@/views/sales/GlobalStrategicPartneradd")
      },
      {
        path: "registeredpartnerjudge",
        name: "registeredpartnerjudge",
        meta: {
          activename: "registeredpartnerjudge"
        },
        component: () => import("@/views/sales/RegisteredPartnerad")
      },
      {
        path: "lier2partnerlist",
        name: "lier2partnerlist",
        meta: {
          activename: "lier2partnerlist"
        },
        component: () => import("@/views/channelUserCen/lier2partnerlist")
      },
      {
        path: "rebatelist",
        name: "rebatelist",
        meta: {
          activename: "rebatelist"
        },
        component: () => import("@/views/channelUserCen/Rebate")
      },
      {
        path: "apreceive",
        name: "apreceive",
        meta: {
          activename: "apreceive"
        },
        component: () => import("@/views/channelUserCen/ApReceive")
      },
      // RAD---签约路由
      {
        path: "radpartner",
        name: "radpartner",
        meta: {
          activename: "RADPartner"
        },
        // component: () => import("@/views/enterpriseNetwork/apply/rad.vue")
        component: () =>
          import("@/views/channelAgreement/twentyTwentySix/EBG/apply/rad.vue")
      },
      // 2025年 RAD Partnert
      // {
      //   path: "radpartnertwo",
      //   name: "radpartnertwo",
      //   meta: {
      //     activename: "RADPartnerTwo"
      //   },
      //   component: () => import("@/views/channelAgreement/twentyTwentyFive/EBG/apply/rad.vue")
      // },
      ...ebg2025,
      ...ebg2026,
      // RAP-Certified Level ---签约路由->新增
      // {
      //   path: "rapcertifiedlevel",
      //   name: "rapcertifiedlevel",
      //   meta: {
      //     activename: "rapcertifiedlevel"
      //   },
      //   component: () => import("@/views/enterpriseNetwork/apply/rap.vue")
      // },
      // RDP---签约路由
      {
        path: "rdppartner",
        name: "rdppartner",
        meta: {
          activename: "rdppartner"
        },
        // component: () => import("@/views/signUpProcess/RdpChannels/RdpPartner")
        // component: () => import("@/views/enterpriseNetwork/apply/rdp.vue")
        component: () =>
          import("@/views/channelAgreement/twentyTwentySix/EBG/apply/rdp.vue")
      },
      // RGP---签约路由->新增
      {
        path: "rgppartner",
        name: "rgppartner",
        meta: {
          activename: "rgppartner"
        },
        // component: () => import("@/views/signUpProcess/RgpChannels/RgpPartner")
        // component: () => import("@/views/enterpriseNetwork/apply/rgp.vue")
        component: () =>
          import("@/views/channelAgreement/twentyTwentySix/EBG/apply/rgp.vue")
      },
      // RSP--签约路由->新增
      {
        path: "rsppartner",
        name: "rsppartner",
        meta: {
          activename: "rsppartner"
        },
        // component: () => import("@/views/signUpProcess/RspChannels/RspPartner")
        // component: () => import("@/views/enterpriseNetwork/apply/rsp.vue")
        component: () =>
          import("@/views/channelAgreement/twentyTwentySix/EBG/apply/rsp.vue")
      },
      //CBGRCSP 互联网
      {
        path: "cbgrcspPartner",
        name: "cbgrcspPartnet",
        meta: {
          activename: "cbgrcspPartner"
        },
        // component: () => import("@/views/signUpProcess/RspChannels/RspPartner")
        component: () => import("@/views/enterpriseNetwork/apply/cbgrcsp.vue")
      },
      // RFFP--签约路由->互联网
      {
        path: "rffpPartner",
        name: "rffppartner",
        meta: {
          activename: "rffppartner"
        },
        // component: () => import("@/views/signUpProcess/RspChannels/RspPartner")
        component: () => import("@/views/enterpriseNetwork/apply/rffp.vue")
      },
      // TBURCSP--签约路由-> 运营商
      {
        path: "tburcspPartner",
        name: "tburcspPartner",
        meta: {
          activename: "tburcspPartner"
        },
        // component: () => import("@/views/signUpProcess/RspChannels/RspPartner")
        component: () => import("@/views/enterpriseNetwork/apply/tburcsp.vue")
      },
      // RCAD--签约路由-> 运营商
      {
        path: "rcadPartner",
        name: "rcadPartner",
        meta: {
          activename: "rcadPartner"
        },
        // component: () => import("@/views/signUpProcess/RspChannels/RspPartner")
        component: () => import("@/views/enterpriseNetwork/apply/rcad.vue")
      },
      // RCAP--签约路由-> 运营商
      {
        path: "rcapPartner",
        name: "rcapPartner",
        meta: {
          activename: "rcapPartner"
        },
        // component: () => import("@/views/signUpProcess/RspChannels/RspPartner")
        component: () => import("@/views/enterpriseNetwork/apply/rcap.vue")
      },
      // 预计去除掉的路由-开始
      // RAD,RDP,RGP,RSP-大区经理审批&国家经理审批
      {
        path: "districtmanagerapproval",
        name: "districtmanagerapproval",
        meta: {
          activename: "districtmanagerapproval"
        },
        component: () => import("@/views/signUpProcess/districtManagerApproval")
      },
      // RCP国家经理审批
      {
        path: "RcpDistrictManagerApproval",
        name: "RcpDistrictManagerApproval",
        meta: {
          activename: "RcpDistrictManagerApproval"
        },
        component: () =>
          import("@/views/signUpProcess/RcpChannels/RcpDistrictManagerApproval")
      },
      // RAD,RDP,RGP,RSP-渠道确认
      {
        path: "ChannelsConfirm",
        name: "ChannelsConfirm",
        meta: {
          activename: "ChannelsConfirm"
        },
        component: () => import("@/views/signUpProcess/ChannelsConfirm")
      },
      // RCP-渠道确认
      {
        path: "RcpChannelsConfirm",
        name: "RcpChannelsConfirm",
        meta: {
          activename: "RcpChannelsConfirm"
        },
        component: () =>
          import("@/views/signUpProcess/RcpChannels/RcpChannelsConfirm")
      },
      // RAD,RDP,RGP,RSP-审批详情页
      {
        path: "examinationApprovalDetails",
        name: "examinationApprovalDetails",
        meta: {
          activename: "examinationApprovalDetails"
        },
        component: () =>
          import("@/views/signUpProcess/examinationApprovalDetails")
      },
      // RCP-审批详情页
      {
        path: "RcpExaminationApprovalDetails",
        name: "RcpExaminationApprovalDetails",
        meta: {
          activename: "RcpExaminationApprovalDetails"
        },
        component: () =>
          import(
            "@/views/signUpProcess/RcpChannels/RcpExaminationApprovalDetails"
          )
      },
      // 预计去除掉的路由-结束

      // smb 申请
      {
        path: "smb-sales-apply",
        name: "smbSalesApply",
        component: () => import("@/views/smbSales/apply/apply")
      },
      // smb 申请成功
      {
        path: "smb-sales-apply-success",
        name: "smbSalesApplySuccess",
        component: () => import("@/views/smbSales/apply/applySuccess")
      },
      // smb 审批
      {
        path: "smb-sales-approve",
        name: "smbSalesApprove",
        component: () => import("@/views/smbSales/approve/index")
      },
      // smb续签
      {
        path: "smb-sales-renewal",
        name: "smbSalesRenew",
        component: () => import("@/views/smbSales/renew/renew")
      },
      // smb编辑
      {
        path: "smb-sales-edit",
        name: "smbSalesEdit",
        component: () => import("@/views/smbSales/edit/index")
      },
      // smb重新提交
      {
        path: "smb-sales-resubmit",
        name: "smbSalesResubmit",
        component: () => import("@/views/smbSales/resubmit/index")
      },
      // smb渠道确认
      {
        path: "smb-sales-channel-confirm",
        name: "smbSalesChannelConfirm",
        component: () =>
          import("@/views/smbSales/channelConfirm/channelConfirm")
      },
      // smb渠道确认成功
      {
        path: "smb-sales-channel-confirm_success",
        name: "smbSalesChannelConfirmSuccess",
        component: () =>
          import("@/views/smbSales/channelConfirm/channelConfirmSuccess")
      },
      // smb详情
      {
        path: "smb-sales-detail",
        name: "smbSalesDetail",
        component: () => import("@/views/smbSales/detail/index")
      },

      // 互联网, 企业网, 运营商 申请成功页面
      {
        path: "net-service-apply-success",
        name: "netServiceApplySuccess",
        component: () => import("@/views/enterpriseNetwork/apply/applySuccess")
      },

      // 互联网, 企业网, 运营商 编辑
      {
        path: "net-service-edit",
        name: "netServiceEdit",
        component: () => import("@/views/enterpriseNetwork/edit")
      },
      // RCP 编辑 //2024-05-11后端提供tpye为RCP的接口

      {
        path: "net-serviceRCP-edit",
        name: "netServiceRCPEdit",
        component: () => import("@/views/ebgCertifiedPartner/edit")
      },
      // 互联网, 企业网, 运营商 详情
      {
        path: "net-service-detail",
        name: "netServiceDetail",
        component: () => import("@/views/enterpriseNetwork/detail")
      },
      // 互联网, 企业网, 运营商 审批
      {
        path: "net-service-approve",
        name: "netServiceApprove",
        component: () => import("@/views/enterpriseNetwork/approve")
      },

      // 互联网, 企业网, 运营商 渠道确认
      {
        path: "net-service-channel-confirm",
        name: "netServiceChannelConfirm",
        component: () => import("@/views/enterpriseNetwork/channelConfirm")
      },

      // 互联网, 企业网, 运营商 渠道确认成功页面
      {
        path: "net-service-channel-confirm-success",
        name: "netServiceChannelConfirmSuccess",
        component: () =>
          import(
            "@/views/enterpriseNetwork/channelConfirm/channelConfirmSuccess"
          )
      },

      // 互联网, 企业网, 运营商 重新提交
      {
        path: "net-service-resubmit",
        name: "netServiceResubmit",
        component: () => import("@/views/enterpriseNetwork/resubmit")
      },
      // RCP---签约路由->新增
      {
        path: "rcppartner",
        name: "rcppartner",
        meta: {
          activename: "rcppartner"
        },
        // component: () => import("@/views/signUpProcess/RcpChannels/RcpPartner")
        // component: () => import("@/views/enterpriseNetwork/apply/rcp.vue")
        component: () =>
          import("@/views/channelAgreement/twentyTwentySix/EBG/apply/rcp.vue")
        // component: () => import("@/views/ebgCertifiedPartner/apply")
      },

      ...smb2025,
      ...smb2026
      // RCP 详情  5-17 注释的全部删除
      // {
      //   path: "net-service-detail-RCP",
      //   name: "netServiceDetailRCP",
      //   component: () => import("@/views/ebgCertifiedPartner/detail")
      // },
      // {
      //   path: "net-service-apply-success-RCP",
      //   name: "netServiceApplySuccess-RCP",
      //   component: () => import("@/views/ebgCertifiedPartner/apply/applySuccess")
      // },
      // // RAP-Certified Level 渠道 审批
      // {
      //   path: "net-service-channel-approve-RCP",
      //   name: "net-service-channel-approve-RCP",
      //   component: () => import("@/views/ebgCertifiedPartner/approve/index.vue")
      // },
      // // RAP-Certified Level 重新提交
      // {
      //   path: "net-service-resubmit-RCP",
      //   name: "netServiceResubmit-RCP",
      //   component: () => import("@/views/ebgCertifiedPartner/resubmit")
      // },
      // // RAP-Certified Level 渠道确认
      // {
      //   path: "net-service-channel-confirm-RCP",
      //   name: "net-service-channel-confirm-RCP",
      //   component: () => import("@/views/ebgCertifiedPartner/channelConfirm")
      // },
      // // RAP-Certified Level 渠道确认成功页面
      // {
      //   path: "net-service-channel-confirm-RCP-success",
      //   name: "netServiceChannelConfirmRCPSuccess",
      //   component: () => import("@/views/ebgCertifiedPartner/channelConfirm/channelConfirmSuccess")
      // },
    ]
  }
];

//系统管理路由
export const manage = [
  {
    path: "/manage",
    name: "manage",
    redirect: "/Pending",
    component: () => import("@/views/layout/ContentMenu"),
    hidden: true,
    children: [
      // 去除切换用户，由主站后台进行切换
      // {
      //   path: "SwitchingIdentity",
      //   name: "SwitchingIdentity",
      //   meta: {
      //     activename: "SwitchingIdentity"
      //   },
      //   component: () => import("@/views/manage/SwitchingIdentity")
      // },
      {
        path: "SysMenuManagement",
        name: "SysMenuManagement",
        meta: {
          activename: "SysMenuManagement"
        },
        component: () => import("@/views/manage/SysMenuManagement")
      },
      {
        path: "InterfaceManagement",
        name: "InterfaceManagement",
        meta: {
          activename: "InterfaceManagement"
        },
        component: () => import("@/views/manage/InterfaceManagement")
      },
      {
        path: "AreaManagement",
        name: "AreaManagement",
        meta: {
          activename: "AreaManagement"
        },
        component: () => import("@/views/manage/AreaManagement")
      },
      {
        path: "AreaForm",
        name: "AreaForm",
        meta: {
          activename: "AreaForm"
        },
        component: () => import("@/views/manage/AreaForm")
      },
      {
        path: "RoleManagement",
        name: "RoleManagement",
        meta: {
          activename: "RoleManagement"
        },
        component: () => import("@/views/manage/RoleManagement")
      },
      {
        path: "UserManagement",
        name: "UserManagement",
        meta: {
          activename: "UserManagement"
        },
        component: () => import("@/views/manage/UserManagement")
      },
      {
        path: "Content",
        name: "Content",
        meta: {
          activename: "Content"
        },
        component: () => import("@/views/manage/Content")
      },
      {
        path: "ContentForm",
        name: "ContentForm",
        meta: {
          activename: "ContentForm"
        },
        component: () => import("@/views/manage/ContentForm")
      },
      {
        path: `RoleUser`,
        name: `RoleUser`,
        meta: {
          activename: `RoleUser`
        },
        component: () => import(`@/views/manage/RoleUser`)
      },
      {
        path: `RoleInterface`,
        name: `RoleInterface`,
        meta: {
          activename: `RoleInterface`
        },
        component: () => import(`@/views/manage/RoleInterface`)
      },
      {
        path: `RoleMenu`,
        name: `RoleMenu`,
        meta: {
          activename: `RoleMenu`
        },
        component: () => import(`@/views/manage/RoleMenu`)
      },
      {
        path: "InfoCatManagement",
        name: "UserMInfoCatManagementanagement",
        meta: {
          activename: "InfoCatManagement"
        },
        component: () => import("@/views/manage/InfoCatManagement")
      },
      {
        path: "interfaceData",
        name: "interfaceData",
        meta: {
          activename: "InterfaceData"
        },
        component: () => import("@/views/manage/InterfaceData")
      },
      {
        path: "sendmailhandly",
        name: "sendmailhandly",
        meta: {
          activename: "SendMailHandly"
        },
        component: () => import("@/views/manage/SendMailHandly")
      },
      {
        path: "importRebate",
        name: "importRebate",
        meta: {
          activename: "ImportRebate"
        },
        component: () => import("@/views/manage/ImportRebate")
      },
      {
        path: "rebateDetail",
        name: "rebateDetail",
        meta: {
          activename: "RebateDetail"
        },
        component: () => import("@/views/manage/RebateDetail")
      }
    ]
  }
];

//签约模板路由
export const templ = [
  {
    path: "/templ",
    name: "templ",
    redirect: "/list",
    component: () => import("@/views/layout/ContentMenu"),
    hidden: true,
    children: [
      {
        path: "list",
        name: "list",
        meta: {
          activename: "list"
        },
        component: () => import("@/views/templ/TemplateList")
      },
      {
        path: "add",
        name: "add",
        meta: {
          activename: "add"
        },
        component: () => import("@/views/templ/addTemplate")
      },
      {
        path: "update",
        name: "update",
        meta: {
          activename: "update"
        },
        component: () => import("@/views/templ/updateTemplate")
      }
    ]
  }
];

//账号管理
export const accountManagement = [
  {
    path: "/accountManagement",
    name: "accountManagement",
    redirect: "/Pending",
    component: () => import("@/views/layout/ContentMenu"),
    hidden: true,
    children: [
      {
        path: "masterAccount",
        name: "MasterAccount",
        meta: {
          activename: "MasterAccount"
        },
        component: () => import("@/views/accountManagement/MasterAccount")
      },
      {
        path: "subAccount",
        name: "SubAccount",
        meta: {
          activename: "SubAccount"
        },
        component: () => import("@/views/accountManagement/SubAccount")
      },
      {
        path: "PendingForAccount",
        name: "PendingForAccount",
        meta: {
          activename: "PendingForAccount"
        },
        component: () => import("@/views/accountManagement/PendingForAccount")
      },
      {
        path: "MyRGID",
        name: "MyRGID",
        meta: {
          activename: "MyRGID"
        },
        component: () => import("@/views/accountManagement/MyRGID")
      }
    ]
  }
];

//resources
export const resourcesManagement = [
  {
    path: "/resources",
    name: "resources",
    redirect: "/resources/list",
    component: () => import("@/views/resLayout/resourcesMenu"),
    hidden: true,
    children: [
      {
        path: "list",
        name: "list",
        meta: {
          activename: "list"
        },
        component: () => import("@/views/resources/resourcesList")
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/routes.js